import BreadCrumbs from './BreadCrumbs';

export { BreadCrumbs };



// WEBPACK FOOTER //
// ./src/modules/home/BreadCrumbs/index.js